import React from 'react';

import { MantineColor, Skeleton, Title, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useLocalization } from 'context/localization-context';

interface InvoiceReportTotalProps {
  /** The report's totals query — loading, error and success are all rendered. */
  query: { data?: { data: { total: number } }; isLoading: boolean; isSuccess: boolean; isError: boolean };
  color: MantineColor;
  /** Set false to withhold the amount even on success (Total Revenue needs a date range). */
  isReady?: boolean;
}

/**
 * A report's filter-aware headline total.
 *
 * The amount comes from the report's own endpoint, which now receives the same
 * `payment_methods` parameter as the table, so the number and the rows below it
 * always agree.
 */
const InvoiceReportTotal = ({ query, color, isReady = true }: InvoiceReportTotalProps): JSX.Element => {
  const theme = useMantineTheme();
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.sm}`, false);
  const { formatCurrency } = useLocalization();
  const order = isDesktop ? 1 : 3;

  if (query.isLoading) {
    return <Skeleton height='2rem' width='5rem' />;
  }
  if (query.isError) {
    return (
      <Title order={order} color='red'>
        Error
      </Title>
    );
  }
  if (query.isSuccess && query.data && isReady) {
    return (
      <Title order={order} color={color}>
        {formatCurrency(query.data.data.total / 100)}
      </Title>
    );
  }
  return <></>;
};

export default InvoiceReportTotal;
